import React from 'react';
import './Contact.css';
import ContactForm from './ContactForm';

function Contact() {
 return (
   <div className="Contact">
     <h1 className="title">Contact Us</h1>
     <div className="ContactFormContainer">
       <ContactForm />
     </div>
   </div>
 );
}

export default Contact;
